import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, PieChart, Pie, Cell } from 'recharts';
import { Download, Filter } from 'lucide-react';
const barData = [{
  name: 'জানু',
  submitted: 45,
  approved: 30,
  returned: 5
}, {
  name: 'ফেব্রু',
  submitted: 50,
  approved: 40,
  returned: 8
}, {
  name: 'মার্চ',
  submitted: 60,
  approved: 45,
  returned: 10
}, {
  name: 'এপ্রিল',
  submitted: 40,
  approved: 35,
  returned: 2
}, {
  name: 'মে',
  submitted: 55,
  approved: 50,
  returned: 4
}, {
  name: 'জুন',
  submitted: 70,
  approved: 60,
  returned: 5
}];
const pieData = [{
  name: 'অনুমোদিত',
  value: 60
}, {
  name: 'অপেক্ষমাণ',
  value: 20
}, {
  name: 'ফেরত',
  value: 10
}, {
  name: 'খসড়া',
  value: 10
}];
const COLORS = ['#10b981', '#3b82f6', '#f59e0b', '#64748b'];
export const GadgetReports: React.FC = () => {
  return <div className="max-w-7xl mx-auto" data-id="element-730">
      <div className="flex justify-between items-end mb-6" data-id="element-731">
        <div data-id="element-732">
          <h1 className="text-2xl font-bold text-slate-900" data-id="element-733">
            গেজেট প্রকাশনা রিপোর্ট
          </h1>
          <p className="text-slate-500" data-id="element-734">
            গেজেট প্রকাশনার মাসিক পরিসংখ্যান এবং বর্তমান অবস্থা
          </p>
        </div>
        <div className="flex space-x-3" data-id="element-735">
          <button className="btn-secondary flex items-center text-sm" data-id="element-736">
            <Filter size={16} className="mr-2" data-id="element-737" /> ফিল্টার
          </button>
          <button className="btn-primary flex items-center text-sm" data-id="element-738">
            <Download size={16} className="mr-2" data-id="element-739" /> রিপোর্ট এক্সপোর্ট করুন
          </button>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-8" data-id="element-740">
        <div className="card p-5 border-t-4 border-t-blue-500" data-id="element-741">
          <p className="text-sm font-medium text-slate-500 mb-1" data-id="element-742">মোট জমাদান</p>
          <p className="text-3xl font-bold text-slate-900" data-id="element-743">৩২০</p>
          <p className="text-xs text-blue-600 mt-2" data-id="element-744">চলতি বছরে</p>
        </div>
        <div className="card p-5 border-t-4 border-t-green-500" data-id="element-745">
          <p className="text-sm font-medium text-slate-500 mb-1" data-id="element-746">অনুমোদিত</p>
          <p className="text-3xl font-bold text-slate-900" data-id="element-747">২৬০</p>
          <p className="text-xs text-green-600 mt-2" data-id="element-748">৮১% অনুমোদনের হার</p>
        </div>
        <div className="card p-5 border-t-4 border-t-amber-500" data-id="element-749">
          <p className="text-sm font-medium text-slate-500 mb-1" data-id="element-750">ফেরত</p>
          <p className="text-3xl font-bold text-slate-900" data-id="element-751">৩৪</p>
          <p className="text-xs text-amber-600 mt-2" data-id="element-752">সংশোধনের জন্য</p>
        </div>
        <div className="card p-5 border-t-4 border-t-teal-500" data-id="element-753">
          <p className="text-sm font-medium text-slate-500 mb-1" data-id="element-754">প্রকাশিত</p>
          <p className="text-3xl font-bold text-slate-900" data-id="element-755">২০০</p>
          <p className="text-xs text-teal-600 mt-2" data-id="element-756">চূড়ান্ত প্রজ্ঞাপন</p>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-757">
        <div className="card p-6 lg:col-span-2" data-id="element-758">
          <div className="flex justify-between items-center mb-6" data-id="element-759">
            <h2 className="font-semibold text-slate-800" data-id="element-760">
              মাসিক জমাদান ও অনুমোদন (২০২৫)
            </h2>
          </div>
          <div className="h-80" data-id="element-761">
            <ResponsiveContainer width="100%" height="100%" data-id="element-762">
              <BarChart data={barData} margin={{
              top: 5,
              right: 30,
              left: 20,
              bottom: 5
            }} data-id="element-763">
                <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#e2e8f0" data-id="element-764" />
                <XAxis dataKey="name" axisLine={false} tickLine={false} tick={{
                fill: '#64748b'
              }} data-id="element-765" />
                <YAxis axisLine={false} tickLine={false} tick={{
                fill: '#64748b'
              }} data-id="element-766" />
                <Tooltip cursor={{
                fill: '#f1f5f9'
              }} contentStyle={{
                borderRadius: '8px',
                border: 'none',
                boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1)'
              }} data-id="element-767" />
                <Legend data-id="element-768" />
                <Bar dataKey="submitted" name="জমাদান" fill="#3b82f6" radius={[4, 4, 0, 0]} data-id="element-769" />
                <Bar dataKey="approved" name="অনুমোদিত" fill="#10b981" radius={[4, 4, 0, 0]} data-id="element-770" />
                <Bar dataKey="returned" name="ফেরত" fill="#f59e0b" radius={[4, 4, 0, 0]} data-id="element-771" />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>

        <div className="card p-6" data-id="element-772">
          <h2 className="font-semibold text-slate-800 mb-6" data-id="element-773">
            বর্তমান স্ট্যাটাস বন্টন
          </h2>
          <div className="h-64" data-id="element-774">
            <ResponsiveContainer width="100%" height="100%" data-id="element-775">
              <PieChart data-id="element-776">
                <Pie data={pieData} cx="50%" cy="50%" innerRadius={60} outerRadius={80} paddingAngle={5} dataKey="value" data-id="element-777">
                  {pieData.map((entry, index) => <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} data-id="element-778" />)}
                </Pie>
                <Tooltip contentStyle={{
                borderRadius: '8px',
                border: 'none',
                boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1)'
              }} data-id="element-779" />
              </PieChart>
            </ResponsiveContainer>
          </div>
          <div className="mt-4 space-y-2" data-id="element-780">
            {pieData.map((entry, index) => <div key={index} className="flex items-center justify-between text-sm" data-id="element-781">
                <div className="flex items-center" data-id="element-782">
                  <div className="w-3 h-3 rounded-full mr-2" style={{
                backgroundColor: COLORS[index]
              }} data-id="element-783"></div>
                  <span className="text-slate-600" data-id="element-784">{entry.name}</span>
                </div>
                <span className="font-medium text-slate-900" data-id="element-785">
                  {entry.value}%
                </span>
              </div>)}
          </div>
        </div>
      </div>
    </div>;
};